export default "__VITE_ASSET__DaHbKr$D__"